import { createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_FULL } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.ROOT)({
  component: Home,
  staticData: {
    config: {
      title: "home",
    },
  },
});

function Home() {
  return (
    <>
      <h1>Hello world!</h1>
    </>
  );
}
